import React, { useEffect, useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Paper,
	TextField,
	Box,
} from "@mui/material";
import "../../../css/empresa_uno/ventas.css";
import pdf from "../../../images/pdf.png";
import buscar_azul from "../../../images/search_azul.png";
import { ApiService } from "../../ApiService";
import { useParams } from "react-router-dom";
import { useCompanyAssigned } from "../../CompanyAssignedContext";
import LupaIcon from "../../../svg/lupaIcon";
import pdfIcon from "../../../images/pdf.png";
import SearchCompany from "../../../pages/empresa_uno/SearchCompany";
import TablesMobile from "../../empresa/TablesMobile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

export const VnotaAnuladas = ({ selectedSucursal, convertPrice = (() => { }) }) => {
	const { nit, sub_direc } = useParams();

	const [sucursales, setSucursales] = useState([]);
	const [objOpeCan, setObjOpeCan] = useState([]);
	const [fechaIni, setFechaIni] = useState(null);
	const [fechaFin, setFechaFin] = useState(null);
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const fetchOpeCan = async (key_branch, fecha1, fecha2) => {
		const url = `api/company/sale/cancel?start_date=${fecha1}&end_date=${fecha2}&key_branch=${key_branch}`;
		const options = { method: "GET" };
		const request_totals = await ApiService.fetchData(url, options);
		if (!request_totals) {
			alert("Error al cargar los datos de ventas del día");
			return;
		}
		setObjOpeCan(request_totals);
	};



	useEffect(() => {
		const current_suc = selectedSucursal;
		const comp_date = new Date();
		const currentDate = `${comp_date.getFullYear()}-${String(comp_date.getMonth() + 1).padStart(2, "0")}-${String(comp_date.getDate()).padStart(2, "0")}`;

		if (fechaIni == null && fechaFin == null) {
			setFechaFin(currentDate);
			setFechaIni(currentDate);
		}

		setSucursales(current_suc);
		fetchOpeCan(current_suc, fechaIni || currentDate, fechaFin || currentDate);
	}, [selectedSucursal]);

	function handleChange(e, comp) {
		comp === 1 ? setFechaIni(e) : setFechaFin(e);
		fetchOpeCan(sucursales, comp === 1 ? e : fechaIni, comp === 2 ? e : fechaFin);
	}
	const totalCantidad = objOpeCan?.reduce((acc, note) => parseFloat(acc) + parseFloat(note.qp), 0);
	const totalBeneficio = objOpeCan?.reduce((acc, note) => (parseFloat(acc) + parseFloat(note.earning)).toFixed(2), 0);
	const totalCosto = objOpeCan?.reduce((acc, note) => (parseFloat(acc) + parseFloat(note.cost)).toFixed(2), 0);
	const totalPrecio = objOpeCan?.reduce(
		(acc, note) => (parseFloat(acc) + parseFloat(note.cost) + parseFloat(note.earning)).toFixed(2),
		0
	);
	const formatSum = (cost, earning) => {
		const total = parseFloat(cost) + parseFloat(earning);
		return total.toFixed(2);
	};

	const returnTotal = () => {
		return totalPrecio;
	}

	return (
		<>
			<div className="functionality-container">
				<div className="header-reports">
					<h2 style={{ color: 'var(--theme-company)' }}>Nota Anuladas</h2>

					<div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
						<TextField
							label="Fecha Inicial"
							type="date"
							value={fechaIni}
							onChange={(e) => handleChange(e.target.value, 1)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>

						<TextField
							label="Fecha Fin"
							type="date"
							value={fechaFin}
							onChange={(e) => handleChange(e.target.value, 2)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</div>

					<div>
						<SearchCompany theme={'var(--theme-company)'} placeholder="ventas anuladas" />

						<div style={{ display: 'none' }}>
							<button className="btn-add-var">
								<img className="icon-down pdf-icon" src={pdfIcon} alt="pdf" />
								<span className="txt-add">PDF</span>
							</button>
						</div>
					</div>
				</div>
			</div>

			{
				currentSize > 480 ? (
					<div className="table-view-pc">
						<TableContainer component={Paper}>
							<Table>
								<TableHead>
									<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
										{[
											"N°",
											"Fecha",
											"Cliente",
											"Código",
											"Producto",
											"Cantidad",
											"Costo",
											"Beneficio",
											"Precio",
										].map((header, index) => (
											<TableCell
												key={`${index}${header}`}
												sx={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
												{header}
											</TableCell>
										))}
									</TableRow>
								</TableHead>

								<TableBody>
									{objOpeCan?.map((note) => (
										<TableRow key={note.nro}>
											<TableCell align="center">{note.nro}</TableCell>
											<TableCell align="center">{note.date_cancel}</TableCell>
											<TableCell align="center">{note.client_name}</TableCell>
											<TableCell align="center">{note.code}</TableCell>
											<TableCell align="center">{note.product_name}</TableCell>
											<TableCell align="center">{note.qp}</TableCell>
											<TableCell align="center">{convertPrice(note.cost, null, true)}</TableCell>
											<TableCell align="center">{convertPrice(note.earning, null, true)}</TableCell>
											<TableCell align="center">{convertPrice(formatSum(note.cost, note.earning), null, true)}</TableCell>
										</TableRow>
									))}
								</TableBody>

								<TableFooter>
									<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
											Total
										</TableCell>
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
											{totalCantidad}
										</TableCell>
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
											{convertPrice(totalCosto)}
										</TableCell>
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
											{convertPrice(totalBeneficio)}
										</TableCell>
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
											{convertPrice(totalPrecio)}
										</TableCell>
									</TableRow>
								</TableFooter>
							</Table>
						</TableContainer>
					</div>
				) : (
					<TablesMobile filteredData={(objOpeCan ?? []).map(obj => ({
						title: obj?.client_name,
						texto: 'BS. ' + convertPrice(obj?.cost + obj?.earning),
						other: obj?.date_cancel,
						fullPhone: obj?.code_phone + obj?.phone,
					}))} profile={false} whatsapp={true} mode="reportes" facturado={null} returnTotal={returnTotal} />
				)
			}
		</>
	);
};
